<template>
    <div class="tab-menu--main-settings" v-show="showMainSettings">
        <div class="tab-menu--main-setting" @click="showMainSetting('showNameInput')">
            nombre
        </div>
        <div class="tab-menu--main-setting" @click="showMainSetting('showDorsalInput')">
            dorsal
        </div>
        <div class="tab-menu--main-setting" @click="showMainSetting('showPlayerpositionInput')">
            posicion
        </div>
        <div class="tab-menu--main-setting" @click="showMainSetting('showAttackInput')">
            ataque
        </div>
        <div class="tab-menu--main-setting" @click="showMainSetting('showMidfieldInput')">
            medio
        </div>
        <div class="tab-menu--main-setting" @click="showMainSetting('showDefenseInput')">
            defensa
        </div>
    </div>

    <!-- name input -->
    <div class="tab-menu--main-settings tab-menu--main-setting-opened" v-if="showNameInput">
        <input type="text" v-model="cardColors.playerName">
        <div class="close-setting" @click="closeSettingOpened('showNameInput')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </div>
    </div>

    <!-- dorsal input -->
    <div class="tab-menu--main-settings tab-menu--main-setting-opened" v-if="showDorsalInput">
        <input type="number" max="100" step="1" v-model="cardColors.playerDorsal">
        <div class="close-setting" @click="closeSettingOpened('showDorsalInput')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </div>
    </div>

    <!-- position select -->
    <div class="tab-menu--main-settings tab-menu--main-setting-opened" v-if="showPlayerpositionInput">
        <select v-model="cardColors.playerPosition">
            <option value="attack">Attack</option>
            <option value="midfield">Midfield</option>
            <option value="defense">Defense</option>
            <option value="keeper">Keeper</option>
        </select>
        <div class="close-setting" @click="closeSettingOpened('showPlayerpositionInput')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </div>
    </div>

    <!-- attack value input -->
    <div class="tab-menu--main-settings tab-menu--main-setting-opened" v-if="showAttackInput">
        <input type="number" max="100" step="1" v-model="cardColors.attackValue" @blur="checkIfSmallerThan11('attackValue')">
        <div class="close-setting" @click="closeSettingOpened('showAttackInput')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </div>
    </div>

    <!-- midfield value input -->
    <div class="tab-menu--main-settings tab-menu--main-setting-opened" v-if="showMidfieldInput">
        <input type="number" max="100" step="1" v-model="cardColors.midfieldValue" @blur="checkIfSmallerThan11('midfieldValue')">
        <div class="close-setting" @click="closeSettingOpened('showMidfieldInput')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </div>
    </div>

    <!-- defense value input -->
    <div class="tab-menu--main-settings tab-menu--main-setting-opened" v-if="showDefenseInput">
        <input type="number" max="100" step="1" v-model="cardColors.defenseValue" @blur="checkIfSmallerThan11('defenseValue')">
        <div class="close-setting" @click="closeSettingOpened('showDefenseInput')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </div>
    </div>

    
    
</template>
<script>

export default {
    props: ['cardColors'],
    data(){
        return {
            showMainSettings: true,
            showNameInput: false,
            showDorsalInput: false,
            showPlayerpositionInput: false,
            showAttackInput: false,
            showMidfieldInput: false,
            showDefenseInput: false
        }
    },
    components: {
    },
    methods: {
        checkIfSmallerThan11(valToCheck){
            // console.log(valToCheck)
            if(this.cardColors[valToCheck] > 100) {
                console.log('value is too high');
                this.cardColors[valToCheck] = 100
            }
        },
        showMainSetting(setting) {
            this.showMainSettings = false;
            this[setting] = true;
        },
        closeSettingOpened(openedSetting) {
            this[openedSetting] = false;
            this.showMainSettings = true;
        }
    }
}
</script>
<style lang="less">

.tab-menu--main-setting-opened {

    display: flex;
    align-items: center;
    justify-content: space-between;

    .close-setting {
        width: 40px;
        text-align: center;
    }

    input, select {
        height: 40px;
        font-size: 0.8rem;
        padding: 0.2rem;
        margin-right: 1rem;
        width: calc(100% - 3rem);
        border: 0;
        border-radius: 4px;
    }
}

</style>